import { gql } from '@apollo/client'

export const DELETE_COMPANY_PRICE = gql`
  mutation DeletePrice($id: ID!) {
    deleteCompanyPrice(id: $id)
  }
`
